import DailyMapGame from './DailyMapGame';

const MapGuessingContainer = () => <DailyMapGame />;

export default MapGuessingContainer;
